<template>
  <button
    :type="type"
    :class="classes"
    :disabled="loading || disabled"
    v-on="$listeners"
  >
    <span class="app-button__spinner" aria-hidden="true">
      <span v-if="loading" class="spinner-border spinner-border-sm" role="status" />
    </span>
    <span :class="{ 'app-button__label--hidden': loading }">
      <slot />
    </span>
  </button>
</template>

<script>
export default {
  name: 'AppButton',
  props: {
    type: { type: String, default: 'button' },
    variant: { type: String, default: 'primary' },
    size: { type: String, default: null },
    block: { type: Boolean, default: true },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },
  computed: {
    classes() {
      return [
        'btn',
        `btn-${this.variant}`,
        this.block ? 'btn-block' : null,
        this.size ? `btn-${this.size}` : null
      ].filter(Boolean)
    }
  }
}
</script>

<style scoped>
.app-button__spinner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.app-button__label--hidden {
  visibility: hidden;
}

button {
  position: relative;
}
</style>



// WEBPACK FOOTER //
// src/components/AppButton.vue